import darkModeLogo from '@/assets/getsign-logo-dark-mode.svg';
import logo from '@/assets/getsign-logo.svg';
import { useColorTheme } from '@/context/ColorThemeContext';

const HeaderContainer = ({ children }: { children: React.ReactNode }) => {
  const { isDarkTheme } = useColorTheme();

  return (
    <header
      className={`z-10 flex items-center justify-between rounded px-8 py-3 shadow-md dark:text-white`}
    >
      <img src={isDarkTheme ? darkModeLogo : logo} alt="GetSign" />
      {children}
    </header>
  );
};

export default HeaderContainer;
